import {useNavigate} from "react-router-dom"
import {useFindUserInfo} from "hooks/query/auth.query"
import {getLocalAccessTokenInfo} from "lib/http/token-management"
import {UserInfo} from "dto/auth/Authentication"

export const Top = () => {
    const navigate = useNavigate()
    const tokenInfo = getLocalAccessTokenInfo()
    const {data: userInfo} = useFindUserInfo(tokenInfo)
    const logout = () => {
        navigate("/login")
    }

    const info = userInfo as UserInfo || undefined
    // if (!info) return null
    return (
        <div className="main-top">
            <nav className="topnav">
                <div className="topnav-brand">
                    <h1 className="text-blue-900 text-2xl">플랫폼 공통 관리</h1>
                    <span className="text-xs">(PLATFORM COMMON MANAGEMENT)</span>
                </div>
                <div className="topnav-menu">
                    <div className="topnav-start">
                        <div className="topnav-item">
                        </div>
                    </div>
                    <div className="topnav-end">
                        <div className="navbar-item has-dropdown is-hoverable">
                            <a className="navbar-link">
                                <div className="member-box">
                                    <div className="membericon">
                                        <span className="icon">
                                            <i className="fas fa-user"/>
                                        </span>
                                    </div>
                                </div>
                                <div className="membertext">
                                    {info?.name || ""}
                                </div>
                            </a>
                            <div className="navbar-dropdown">
                                <a className="navbar-item" onClick={() => logout()}>
                                    logout
                                </a>
                            </div>
                        </div>

                    </div>
                </div>
            </nav>
        </div>
    )
}